import { useEffect, useState } from 'react';
import api from '../api';

// Cache compartilhado { userId: url } com as fotos de perfil, para as telas que só têm o id do jogador
// (confirmação, times, estatísticas, ranking). Carregado uma vez e atualizado quando alguém troca a foto.
let fotos = null;
let carregando = null;
const ouvintes = new Set();

const avisar = () => ouvintes.forEach((ouvinte) => ouvinte(fotos));

function carregar() {
  if (fotos || carregando) return carregando;
  carregando = api
    .get('user/fotos')
    .then((response) => {
      fotos = response.data.fotos || {};
      avisar();
    })
    .catch(() => {
      carregando = null; // tenta de novo na próxima tela
    });
  return carregando;
}

// Atualiza (ou remove, com foto vazia) a foto de um usuário no cache.
export function atualizarFotoCache(userId, foto) {
  if (!userId) return;
  fotos = { ...(fotos || {}) };
  if (foto) fotos[String(userId)] = foto;
  else delete fotos[String(userId)];
  avisar();
}

// Foto de perfil do usuário pelo id (undefined enquanto carrega ou se não houver foto).
export function useFotoUsuario(userId) {
  const [mapa, setMapa] = useState(fotos);

  useEffect(() => {
    if (!userId) return undefined;
    ouvintes.add(setMapa);
    carregar();
    return () => ouvintes.delete(setMapa);
  }, [userId]);

  return userId && mapa ? mapa[String(userId)] : undefined;
}
